import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
export const TransactionFilters = [
    {
        title: "Filter by (2)",
        checkboxes: [
            "Approximated/Editable Transactions",
            "Buy Transactions",
            "Sell Transactions",
        ],
    },
    {
        title: "Asset Filters (0)",
        checkboxes: [
            "Equity",
            "Fixed Income",
            "Derivative",
            "Managed Portfolio",
            "Commodity",
            "Real Estate",
        ],
    },
    {
        title: "Product Type Filters (2)",
        checkboxes: [
            "Listed Equity",
            "Unlisted Equity",
            "Certificate of Deposite",
            "Commercial Paper",
            "NCD",
            "Warrant",
        ],
    },
];
export const EachrowTransactiondata = [
    {
        title: "Net Value",
        key: "netValue",
    },
    {
        title: "Brokerage & Charges",
        key: "netCharges",
    },
    {
        title: "Brokerage",
        key: "brokerage",
    },
    {
        title: "STax/GST on Brok",
        key: "stax_GST",
    },
    {
        title: "STT",
        key: "stt",
    },
    {
        title: "Stamp Duty",
        key: "stampDutyCharges",
    },
    {
        title: "SEBI Fees",
        key: "sebiTax",
    },
    {
        title: "Txn Charges",
        key: "transactionCharge",
    },
    {
        title: "Tax on Txn Charges",
        key: "tstax",
    },
    {
        title: "Other Charges",
        key: "other",
    },
];
export var transactionHistoryTabsType;
(function (transactionHistoryTabsType) {
    transactionHistoryTabsType["FILTERS"] = "Filters";
    transactionHistoryTabsType["SORT"] = "Sort";
})(transactionHistoryTabsType || (transactionHistoryTabsType = {}));
export const transactionHistoryTabs = [
    {
        title: "Filters",
        eventKey: transactionHistoryTabsType.FILTERS,
    },
    {
        title: "Sort",
        eventKey: transactionHistoryTabsType.SORT,
    },
];
export var TH_SECTION_MOB;
(function (TH_SECTION_MOB) {
    TH_SECTION_MOB["TH_MAIN"] = "TH_MAIN";
    TH_SECTION_MOB["APPROX_TXNS"] = "APPROX_TXNS";
    TH_SECTION_MOB["DOWNLOAD_TXNS"] = "DOWNLOAD_TXNS";
    TH_SECTION_MOB["TH_SCRIP_DETAIL"] = "TH_SCRIP_DETAIL";
    TH_SECTION_MOB["TH_VIEW_ALL"] = "TH_VIEW_ALL";
})(TH_SECTION_MOB || (TH_SECTION_MOB = {}));
export const sortlistTH = new Sorts([
    {
        title: "Transaction Date",
        key: "transactionDate",
        order: ESortOrder.DESC,
        orderText: { asc: "Oldest to Newest", desc: "Newest To Oldest" },
        type: "Date",
    },
    {
        title: "Scrip Name",
        key: "security",
        order: ESortOrder.UNCHANGED,
        orderText: { asc: "Z to A", desc: "A to Z" },
        type: "string",
    },
    {
        title: "Quantity",
        key: "quantity",
        order: ESortOrder.UNCHANGED,
        orderText: { desc: "Highest to Lowest ", asc: "Lowest to Highest" },
        type: "number",
    },
    {
        title: "Price",
        key: "transactionPrice",
        order: ESortOrder.UNCHANGED,
        orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
        type: "number",
    },
    {
        title: "Net",
        key: "netValue",
        order: ESortOrder.UNCHANGED,
        orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
        type: "number",
    },
]);
export var THVIEWS;
(function (THVIEWS) {
    THVIEWS["MAIN_LANDING"] = "main";
    THVIEWS["APPROXIMATEDTXNS"] = "approx";
})(THVIEWS || (THVIEWS = {}));
export const THApproximateTrans = "Below are the transactions we have approximated please review the date, price, and quantity for each. If they seem accurate, kindly save them. To make any changes, click the edit icon next to the relevant transaction in the list below.";
export const THApproximateTransEditsDone = "Edits to your transaction have been saved. Please proceed with other approximable transactions";
